/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Form, Modal, Space, InputNumber, message, DatePicker, Button } from 'antd';
import emiter, { _EVENTS } from '../../../../events';
import { ExclamationCircleTwoTone } from '@ant-design/icons';
import moment from 'moment';
import { useCarModelPrice } from '../../../../hooks/product-price/car-model-price';
import { jsonParseData } from '../../../../utils';

const { RangePicker } = DatePicker;

interface PropsType {
	enums?: any;
	detail?: any;
}

function getDate(datestr: string) {
	var temp: any = datestr.split('-');
	var date = new Date(temp[0], temp[1] - 1, temp[2]);
	return date;
}

function getAll(start: any, end: any) {
	let dateList = [];
	var startTime = getDate(start);
	var endTime = getDate(end);

	while (endTime.getTime() - startTime.getTime() >= 0) {
		var year = startTime.getFullYear();
		var month = startTime.getMonth() + 1 < 10 ? '0' + (startTime.getMonth() + 1) : startTime.getMonth() + 1;
		var day = startTime.getDate().toString().length === 1 ? '0' + startTime.getDate() : startTime.getDate();
		dateList.push(year + '-' + month + '-' + day);
		startTime.setDate(startTime.getDate() + 1);
	}
	return dateList;
}

const IntervalPrice: React.FC<PropsType> = props => {
	const { detail } = props;
	const { update, getSaasApolloConfig, tableActionEdit } = useCarModelPrice();

	const [form] = Form.useForm();
	const [showModal, setShowModal] = useState(false);
	const [holidayList, setHolidayList] = useState<any>([]);
	const [dateArr, setDateArr] = useState<any>([]);

	const mainFormFields = {
		// mingcheng: {
		// 	name: 'name',
		// 	label: '名称',
		// 	required: true,
		// 	message: '请输入名称',
		// 	placeholder: '请输入名称',
		// },
		riqi: {
			name: 'date',
			label: '日期',
			required: true,
			message: '请选择日期',
			placeholder: '请选择日期',
		},
		jiage: {
			name: 'price',
			label: '价格',
			required: true,
			message: '请输入价格',
			placeholder: '请输入价格',
		},
	};

	const openModal = () => {
		setShowModal(true);
	};

	// 关闭弹窗
	const closeModal = () => {
		form.resetFields();
		setShowModal(false);
	};

	const formatPrice = (price: any) => {
		if (!price) return price;
		if (!isNaN(Number(price))) {
			price = price * 100;
		}
		return price;
	};

	// 添加区间定价
	const addIntervalPrice = () => {
		form.validateFields().then(async (fieldsValue: any) => {
			const holiday = dateArr.map((item: any) => {
				return {
					day: item,
					price: formatPrice(fieldsValue.price),
				};
			});
			const params = {
				...detail,
			};
			if (params.price_detail) {
				params.price_detail.holiday = holiday;
			} else {
				params.price_detail = {};
				params.price_detail.holiday = holiday;
			}
			const result: any = await update(params);
			if (result.errno === 0) {
				message.success('操作成功');
				closeModal();
				tableActionEdit(detail);
			}
		});
	};

	const tagClick = (item: any) => {
		const dateRanges: any = item.date_ranges;
		if (Array.isArray(dateRanges)) {
			const res = getAll(dateRanges[0], dateRanges[1]);
			form.setFieldValue('date', [moment(dateRanges[0]), moment(dateRanges[1])]);
			setDateArr(res);
		}
	};

	const handlePickerChange = (date: any, dateStrings: any) => {
		const res = getAll(dateStrings[0], dateStrings[1]);
		setDateArr(res);
	};

	const filterUpcomingHolidays = (holidays: any[]) => {
		const currentDate = new Date();
		const threeMonthsLater = new Date();
		threeMonthsLater.setMonth(currentDate.getMonth() + 4);

		return holidays.filter(holiday => {
			const startDate = new Date(holiday.date_ranges[0]);
			return startDate >= currentDate && startDate <= threeMonthsLater;
		});
	};

	const validatePrice = (_: any, value: any) => {
		if (!value) {
			return Promise.reject(new Error('请输入价格'));
		}
		if (value > 5000 || value < 1) {
			return Promise.reject(new Error('请输入1-5000的正整数'));
		}
		return Promise.resolve();
	};

	useEffect(() => {
		emiter.on(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.INTERVAL_PRICE, openModal);
		getSaasApolloConfig({
			config_name: 'front_enums',
			param_name: 'f_holiday_enum',
		}).then((res: any) => {
			try {
				const list = filterUpcomingHolidays(jsonParseData(res?.data?.f_holiday_enum, []));
				setHolidayList(list);
			} catch (e) {
				console.log(e);
			}
		});
		return () => {
			emiter.removeAllListeners(_EVENTS.PRODUCT_PRICE.CAR_MODEL_PRICE.INTERVAL_PRICE)
		}
	}, []);

	return (
		<Modal title="设置区间价格" width="40%" open={showModal} onCancel={closeModal} centered onOk={addIntervalPrice}>
			<Form form={form}>
				{/* <Form.Item
					label={mainFormFields.mingcheng.label}
					name={mainFormFields.mingcheng.name}
					rules={[
						{
							required: mainFormFields.mingcheng.required,
							message: mainFormFields.mingcheng.message,
						},
					]}
				>
					<Input placeholder={mainFormFields.mingcheng.placeholder} />
				</Form.Item> */}
				<Space align="baseline">
					<Form.Item
						label={mainFormFields.riqi.label}
						name={mainFormFields.riqi.name}
						rules={[
							{
								required: mainFormFields.riqi.required,
								message: mainFormFields.riqi.message,
							},
						]}
					>
						<RangePicker onChange={handlePickerChange} />
					</Form.Item>
					{holidayList?.map?.((item: any) => {
						return (
							<Button
								type="dashed"
								onClick={() => {
									tagClick(item);
								}}
							>
								{item.name}
							</Button>
						);
					})}
				</Space>
				<Form.Item
					required
					label={mainFormFields.jiage.label}
					name={mainFormFields.jiage.name}
					rules={[
						{
							validator: validatePrice,
						},
					]}
				>
					<InputNumber
						placeholder={mainFormFields.jiage.placeholder}
						controls={false}
						addonAfter={<div>元/天</div>}
						precision={0}
					/>
				</Form.Item>
			</Form>
			<Space align="baseline">
				<ExclamationCircleTwoTone twoToneColor="#f82f1e" />
				提交后，价格立即生效
			</Space>
		</Modal>
	);
};

export default IntervalPrice;
